import { gql } from '@apollo/client';
import { cityFragment } from './fragments';

export const CITIES = gql`
  query pagedCities($pager: PagerInputNew, $filters: CityFilters) {
    pagedCities(pager: $pager, filters: $filters) {
      total
      values {
        ...city
      }
    }
  }
  ${cityFragment}
`;

export const CITY = gql`
  query cityHeader($id: Int!) {
    cityHeader(id: $id) {
      ...city
    }
  }
  ${cityFragment}
`;

export const CHILD_CITIES = gql`
  query childCities($parentId: Int!) {
    childCities(parentId: $parentId) {
      ...city
    }
  }
  ${cityFragment}
`;
